import React from "react";
import { Typography } from "@mui/material";
import { Stack } from "components/layout/reusableLayouts";

interface CardHeaderProps {
  title: string;
  subtitle?: string;
}

/**
 * Title + optional subtitle pair, stacked vertically with a token gap. Used
 * as the header for cards/panels that need a labelled section.
 */
const CardHeader: React.FC<CardHeaderProps> = ({ title, subtitle }) => (
  <Stack gap="var(--space-1)">
    <Typography variant="h4" component="h3">
      {title}
    </Typography>
    {subtitle && (
      <Typography variant="label" sx={{ color: "var(--color-text-tertiary)" }}>
        {subtitle}
      </Typography>
    )}
  </Stack>
);

export default CardHeader;
